// Global Airports Directory
// Searchable by city name, IATA code, or country name

export const airports = [
  // United Kingdom - City Groups (All Airports)
  { code: "LON", name: "All London Airports", city: "London", country: "United Kingdom", countryCode: "GB", isGroup: true, includes: ["LHR", "LGW", "STN", "LTN", "LCY"] },
  
  // United Kingdom - Individual Airports
  { code: "LHR", name: "London Heathrow", city: "London", country: "United Kingdom", countryCode: "GB" },
  { code: "LGW", name: "London Gatwick", city: "London", country: "United Kingdom", countryCode: "GB" },
  { code: "STN", name: "London Stansted", city: "London", country: "United Kingdom", countryCode: "GB" },
  { code: "LTN", name: "London Luton", city: "London", country: "United Kingdom", countryCode: "GB" },
  { code: "LCY", name: "London City", city: "London", country: "United Kingdom", countryCode: "GB" },
  { code: "MAN", name: "Manchester Airport", city: "Manchester", country: "United Kingdom", countryCode: "GB" },
  { code: "BHX", name: "Birmingham Airport", city: "Birmingham", country: "United Kingdom", countryCode: "GB" },
  { code: "EDI", name: "Edinburgh Airport", city: "Edinburgh", country: "United Kingdom", countryCode: "GB" },
  { code: "GLA", name: "Glasgow Airport", city: "Glasgow", country: "United Kingdom", countryCode: "GB" },
  { code: "BRS", name: "Bristol Airport", city: "Bristol", country: "United Kingdom", countryCode: "GB" },
  { code: "NCL", name: "Newcastle Airport", city: "Newcastle", country: "United Kingdom", countryCode: "GB" },
  { code: "LBA", name: "Leeds Bradford", city: "Leeds", country: "United Kingdom", countryCode: "GB" },
  { code: "EMA", name: "East Midlands", city: "Nottingham", country: "United Kingdom", countryCode: "GB" },
  { code: "BFS", name: "Belfast International", city: "Belfast", country: "United Kingdom", countryCode: "GB" },
  { code: "CWL", name: "Cardiff Airport", city: "Cardiff", country: "United Kingdom", countryCode: "GB" },
  { code: "ABZ", name: "Aberdeen Airport", city: "Aberdeen", country: "United Kingdom", countryCode: "GB" },
  
  // Saudi Arabia
  { code: "JED", name: "King Abdulaziz International", city: "Jeddah", country: "Saudi Arabia", countryCode: "SA" },
  { code: "MED", name: "Prince Mohammad Bin Abdulaziz", city: "Madinah", country: "Saudi Arabia", countryCode: "SA" },
  { code: "RUH", name: "King Khalid International", city: "Riyadh", country: "Saudi Arabia", countryCode: "SA" },
  { code: "DMM", name: "King Fahd International", city: "Dammam", country: "Saudi Arabia", countryCode: "SA" },
  
  // United Arab Emirates
  { code: "DXB", name: "Dubai International", city: "Dubai", country: "United Arab Emirates", countryCode: "AE" },
  { code: "AUH", name: "Abu Dhabi International", city: "Abu Dhabi", country: "United Arab Emirates", countryCode: "AE" },
  { code: "SHJ", name: "Sharjah International", city: "Sharjah", country: "United Arab Emirates", countryCode: "AE" },
  
  // Qatar
  { code: "DOH", name: "Hamad International", city: "Doha", country: "Qatar", countryCode: "QA" },
  
  // Turkey
  { code: "IST", name: "Istanbul Airport", city: "Istanbul", country: "Turkey", countryCode: "TR" },
  { code: "SAW", name: "Sabiha Gokcen", city: "Istanbul", country: "Turkey", countryCode: "TR" },
  { code: "AYT", name: "Antalya Airport", city: "Antalya", country: "Turkey", countryCode: "TR" },
  
  // Egypt
  { code: "CAI", name: "Cairo International", city: "Cairo", country: "Egypt", countryCode: "EG" },
  { code: "HRG", name: "Hurghada International", city: "Hurghada", country: "Egypt", countryCode: "EG" },
  { code: "SSH", name: "Sharm El Sheikh", city: "Sharm El Sheikh", country: "Egypt", countryCode: "EG" },
  
  // Pakistan
  { code: "ISB", name: "Islamabad International", city: "Islamabad", country: "Pakistan", countryCode: "PK" },
  { code: "LHE", name: "Allama Iqbal International", city: "Lahore", country: "Pakistan", countryCode: "PK" },
  { code: "KHI", name: "Jinnah International", city: "Karachi", country: "Pakistan", countryCode: "PK" },
  
  // India
  { code: "DEL", name: "Indira Gandhi International", city: "Delhi", country: "India", countryCode: "IN" },
  { code: "BOM", name: "Chhatrapati Shivaji", city: "Mumbai", country: "India", countryCode: "IN" },
  { code: "HYD", name: "Rajiv Gandhi International", city: "Hyderabad", country: "India", countryCode: "IN" },
  { code: "BLR", name: "Kempegowda International", city: "Bangalore", country: "India", countryCode: "IN" },
  { code: "CCU", name: "Netaji Subhas Chandra Bose", city: "Kolkata", country: "India", countryCode: "IN" },
  
  // Bangladesh
  { code: "DAC", name: "Hazrat Shahjalal International", city: "Dhaka", country: "Bangladesh", countryCode: "BD" },
  { code: "CGP", name: "Shah Amanat International", city: "Chittagong", country: "Bangladesh", countryCode: "BD" },
  
  // Malaysia
  { code: "KUL", name: "Kuala Lumpur International", city: "Kuala Lumpur", country: "Malaysia", countryCode: "MY" },
  
  // Indonesia
  { code: "CGK", name: "Soekarno-Hatta International", city: "Jakarta", country: "Indonesia", countryCode: "ID" },
  
  // USA
  { code: "JFK", name: "John F Kennedy International", city: "New York", country: "United States", countryCode: "US" },
  { code: "LAX", name: "Los Angeles International", city: "Los Angeles", country: "United States", countryCode: "US" },
  { code: "ORD", name: "O'Hare International", city: "Chicago", country: "United States", countryCode: "US" },
  { code: "DFW", name: "Dallas Fort Worth", city: "Dallas", country: "United States", countryCode: "US" },
  { code: "IAH", name: "George Bush Intercontinental", city: "Houston", country: "United States", countryCode: "US" },
  
  // Canada
  { code: "YYZ", name: "Toronto Pearson", city: "Toronto", country: "Canada", countryCode: "CA" },
  { code: "YVR", name: "Vancouver International", city: "Vancouver", country: "Canada", countryCode: "CA" },
  
  // Germany
  { code: "FRA", name: "Frankfurt Airport", city: "Frankfurt", country: "Germany", countryCode: "DE" },
  { code: "MUC", name: "Munich Airport", city: "Munich", country: "Germany", countryCode: "DE" },
  
  // France
  { code: "CDG", name: "Charles de Gaulle", city: "Paris", country: "France", countryCode: "FR" },
  { code: "ORY", name: "Paris Orly", city: "Paris", country: "France", countryCode: "FR" },
  
  // Netherlands
  { code: "AMS", name: "Amsterdam Schiphol", city: "Amsterdam", country: "Netherlands", countryCode: "NL" },
  
  // Spain
  { code: "MAD", name: "Adolfo Suárez Madrid–Barajas", city: "Madrid", country: "Spain", countryCode: "ES" },
  { code: "BCN", name: "Barcelona El Prat", city: "Barcelona", country: "Spain", countryCode: "ES" },
  
  // Italy
  { code: "FCO", name: "Leonardo da Vinci", city: "Rome", country: "Italy", countryCode: "IT" },
  { code: "MXP", name: "Milan Malpensa", city: "Milan", country: "Italy", countryCode: "IT" },
  
  // Kuwait
  { code: "KWI", name: "Kuwait International", city: "Kuwait City", country: "Kuwait", countryCode: "KW" },
  
  // Bahrain
  { code: "BAH", name: "Bahrain International", city: "Manama", country: "Bahrain", countryCode: "BH" },
  
  // Oman
  { code: "MCT", name: "Muscat International", city: "Muscat", country: "Oman", countryCode: "OM" },
  
  // Jordan
  { code: "AMM", name: "Queen Alia International", city: "Amman", country: "Jordan", countryCode: "JO" },
  
  // Morocco
  { code: "CMN", name: "Mohammed V International", city: "Casablanca", country: "Morocco", countryCode: "MA" },
  
  // Nigeria
  { code: "LOS", name: "Murtala Muhammed International", city: "Lagos", country: "Nigeria", countryCode: "NG" },
  { code: "ABV", name: "Nnamdi Azikiwe International", city: "Abuja", country: "Nigeria", countryCode: "NG" },
  
  // South Africa
  { code: "JNB", name: "OR Tambo International", city: "Johannesburg", country: "South Africa", countryCode: "ZA" },
  { code: "CPT", name: "Cape Town International", city: "Cape Town", country: "South Africa", countryCode: "ZA" },
  
  // Kenya
  { code: "NBO", name: "Jomo Kenyatta International", city: "Nairobi", country: "Kenya", countryCode: "KE" },
  
  // Australia
  { code: "SYD", name: "Sydney Kingsford Smith", city: "Sydney", country: "Australia", countryCode: "AU" },
  { code: "MEL", name: "Melbourne Airport", city: "Melbourne", country: "Australia", countryCode: "AU" },
];

// Search function
export const searchAirports = (query) => {
  if (!query || query.length < 2) return [];
  
  const searchTerm = query.toLowerCase().trim();
  
  return airports.filter(airport => 
    airport.code.toLowerCase().includes(searchTerm) ||
    airport.name.toLowerCase().includes(searchTerm) ||
    airport.city.toLowerCase().includes(searchTerm) ||
    airport.country.toLowerCase().includes(searchTerm)
  ).slice(0, 10); // Limit to 10 results
};

// Get airports by country
export const getAirportsByCountry = (countryCode) => {
  return airports.filter(airport => airport.countryCode === countryCode);
};

// Get popular UK airports for default display
export const getUKAirports = () => {
  return airports.filter(airport => airport.countryCode === "GB");
};

// Get Saudi airports
export const getSaudiAirports = () => {
  return airports.filter(airport => airport.countryCode === "SA");
};

// Country flags mapping
export const countryFlags = {
  GB: "🇬🇧",
  SA: "🇸🇦",
  AE: "🇦🇪",
  QA: "🇶🇦",
  TR: "🇹🇷",
  EG: "🇪🇬",
  PK: "🇵🇰",
  IN: "🇮🇳",
  BD: "🇧🇩",
  MY: "🇲🇾",
  ID: "🇮🇩",
  US: "🇺🇸",
  CA: "🇨🇦",
  DE: "🇩🇪",
  FR: "🇫🇷",
  NL: "🇳🇱",
  ES: "🇪🇸",
  IT: "🇮🇹",
  KW: "🇰🇼",
  BH: "🇧🇭",
  OM: "🇴🇲",
  JO: "🇯🇴",
  MA: "🇲🇦",
  NG: "🇳🇬",
  ZA: "🇿🇦",
  KE: "🇰🇪",
  AU: "🇦🇺"
};
